// AnswerChip component - summary chips showing answered values below radar chart
import * as styles from './AnswerChip.css';
import { AnswerSummaryVM } from '../../view-model/Onboarding.viewModel';

export type AnswerChipProps = {
  vm: AnswerSummaryVM;
};

export type AnswerChipListProps = {
  summaries: AnswerSummaryVM[];
  className?: string;
};

export const AnswerChip = ({ vm }: AnswerChipProps) => {
  return (
    <span className={styles.chip} data-testid={`answer-chip-${vm.questionId}`}>
      {vm.answerText}
    </span>
  );
};

export const AnswerChipList = ({
  summaries,
  className,
}: AnswerChipListProps) => {
  if (summaries.length === 0) {
    return null;
  }

  return (
    <div
      className={
        className ? `${styles.container} ${className}` : styles.container
      }
      data-testid="answer-chip-list"
    >
      {summaries.map((summary) => (
        <AnswerChip key={summary.questionId} vm={summary} />
      ))}
    </div>
  );
};
